import { ReactNode } from "react";
import { clsx } from "clsx";

export function Modal({ open, children, className }: { open: boolean; children: ReactNode; className?: string }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-40 flex items-stretch justify-center bg-stone-950/30 backdrop-blur-sm animate-fade-in md:items-center md:p-6">
      <div
        className={clsx(
          "flex w-full flex-col bg-card animate-slide-up dark:bg-card-dark",
          "md:max-w-[480px] md:animate-scale-in md:rounded-lg md:border md:border-border md:shadow-elevated md:dark:border-border-dark",
          "[padding-top:env(safe-area-inset-top)] [padding-bottom:env(safe-area-inset-bottom)] md:[padding-top:0] md:[padding-bottom:0]",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
